<template>
  <el-dialog :visible.sync="modal" v-if="modal" class="dialog" :closeOnClickModal="false">
    <login v-if="!isForget" :islogin="isLogin" @login="login" @forget="forget"/>
    <forget v-else @forget="forget" :mobile="phone"/>
  </el-dialog>
</template>
<script>
  import login from './modal/login'
  import forget from './modal/forget'
  export default {
    name:'loginDialog',
    components:{ login,forget },
    data(){
      return{
        modal: false,
        isLogin: false,
        isForget: false,
        phone:'',
      }
    },
    mounted() {

    },
    methods:{
      forget(phone){
        phone?this.phone = phone : '';
        this.isForget = !this.isForget;
      },
      login(res){
        this.$emit('state',res);
        setTimeout(_=>{
          this.modal = false;
        },1500)
      },
      dialog(e){
        this.isLogin = e;
        this.modal = true;
      }
    }
  }
</script>
<style scoped>
  >>>.el-dialog__body{
    padding: 0.5rem 0.8rem;
  }
  >>>.el-dialog{
    width: 7.3335rem;
    position: relative;
  }
  >>>.el-form-item__error {
    padding-left: 20px;
  }
  >>>.el-form-item.is-error .el-input__inner,>>>.el-form-item.is-error .el-input__inner:focus, >>>.el-form-item.is-error .el-textarea__inner, >>>.el-form-item.is-error .el-textarea__inner:focus, >>>.el-message-box__input input.invalid, >>>.el-message-box__input input.invalid:focus {
    border-color: #F56C6C!important;
  }
  >>>input::-webkit-outer-spin-button,
  >>>input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  >>>input[type="number"] {
    -moz-appearance: textfield;
  }
  >>>.dialog-login-title{
    margin-bottom: 0.4rem;
  }
  >>>.dialog-login-title h1{
    font-size: 0.4rem;
    color: #333;
    font-weight: initial;
  }
  >>>.login-input .el-input__inner{
    border: none;
    border-bottom: 1px solid rgb(237,237,238);
    border-radius: 0;
    padding: 0 0.1rem;
  }
  >>>.login-input .el-input__inner:focus .el-input-group__append{
    border-bottom: 1px solid #ccc !important;
  }
  >>>.login-input .el-input__inner:focus{
    border-bottom: 1px solid #ccc !important;
  }
  .login-input{
    margin: 0.6rem 0;
  }
  >>>.login-input .el-input{
    display: inline-block;
    width: 90%;
  }

  >>>.login-input .el-input-group__append{
    background: none;
    border-radius: 0;
    border: none;
    color: #00a0e9;
    position: absolute;
    right: 0;
    display: inline-block;
    min-width: 110px;
    top: 0;
    line-height: 39px;
    background: #fff;
    cursor: pointer;
  }
  >>>.login-input .el-input-group .el-input__inner{
    width: 100%;
  }
  >>>.login-input .el-input-group{
    width: 90%;
    display: inline-table;
    position: relative;
  }
  @media only screen and (max-width: 767px){
    >>>.el-dialog{
      max-width: 100%;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/login/loginDialog.vue